/* tslint:disable */
/* eslint-disable */
/**
 * Quotes Management API
 * API for managing quotes
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Command to trigger an SMS code for MNCAP medical validation.
 * @export
 * @interface MncapSendSmsCodeCommand
 */
export interface MncapSendSmsCodeCommand {
    /**
     * The one-time token originally received by the borrower via email.
     * @type {string}
     * @memberof MncapSendSmsCodeCommand
     */
    token: string;
}

/**
 * Check if a given object implements the MncapSendSmsCodeCommand interface.
 */
export function instanceOfMncapSendSmsCodeCommand(value: object): value is MncapSendSmsCodeCommand {
    if (!('token' in value) || value['token'] === undefined) return false;
    return true;
}

export function MncapSendSmsCodeCommandFromJSON(json: any): MncapSendSmsCodeCommand {
    return MncapSendSmsCodeCommandFromJSONTyped(json, false);
}

export function MncapSendSmsCodeCommandFromJSONTyped(json: any, ignoreDiscriminator: boolean): MncapSendSmsCodeCommand {
    if (json == null) {
        return json;
    }
    return {
        
        'token': json['token'],
    };
}

export function MncapSendSmsCodeCommandToJSON(json: any): MncapSendSmsCodeCommand {
    return MncapSendSmsCodeCommandToJSONTyped(json, false);
}

export function MncapSendSmsCodeCommandToJSONTyped(value?: MncapSendSmsCodeCommand | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'token': value['token'],
    };
}

